import { axiosInstance } from '@fides/fides-react-components';
import { AxiosError } from 'axios';
import { CreditTransferOrder, UploadedFile } from '../models';
import { JsonObject } from '../types';
import { endpoints } from '../consts';

export const uploadFilesAction = (_action: string, uniqueIds: UploadedFile['uniqueId'][]): Promise<void> =>
  axiosInstance
    .delete(`${endpoints.upload}/${uniqueIds}`, { baseURL: endpoints.EFTApiUrl })
    .then(() => Promise.resolve())
    .catch((error: AxiosError<JsonObject>) => Promise.reject(error));

export const multiUploadFilesAction = (action: string, uniqueIds: CreditTransferOrder['uniqueId'][]): Promise<void> =>
  axiosInstance
    .post(`${endpoints.upload}/${action}`, [...uniqueIds], { baseURL: endpoints.EFTApiUrl })
    .then(() => Promise.resolve())
    .catch((error: AxiosError<JsonObject>) => Promise.reject(error));
